import domainSort from "../utility/domainSort"

const getPasswordHash = (password) => {
    return "all"
}

const loadFromPersistentData = (hash) => {
    if (window.localStorage) {
        var data = window.localStorage.getItem("singular-key-domains:" + hash)
        if (data !== undefined && data !== null) {
            try {
                 data = JSON.parse(data)
                 if (!(data instanceof Array)) {
                    return []
                 }
                 return data
            } catch (e) {
                return []
            }
        }
    }
    return []
}

const storeToPersistentData = (hash, domains) => {
    if (window.localStorage) {
        window.localStorage.setItem("singular-key-domains:" + hash, JSON.stringify(domains))
    }
}

class DomainStorage
{
    constructor(hash)
    {
        this.listener = null
        this.hash = hash
        this.domains = loadFromPersistentData(this.hash)
    }

    setDomainListener(listener)
    {
        var doUpdate = false
        if (this.listener !== listener) {
            doUpdate = true
        }
        this.listener = listener
        if (doUpdate) {
            this.update()
        }
    }

    update()
    {
        if (this.listener !== null) {
            this.listener.call(null, this.domains)
        }
        storeToPersistentData(this.hash, this.domains)
    }

    removeDomain(domain)
    {
        const originalLength = this.domains.length
        this.domains = this.domains.filter(x => x !== domain)
        this.update()
        return this.domains.length !== originalLength
    }

    addDomain(domain)
    {
        if (!this.domains.includes(domain)) {
            this.domains = [...this.domains, domain]
            domainSort(this.domains)
            this.update()
            return true
        }
        return false
    }
}

const storages = {}

export default (password) => {
    const hash = getPasswordHash(password)
    if (!(hash in storages)) {
        storages[hash] = new DomainStorage(hash)
    }
    return storages[hash]
}
